module.exports = __webpack_public_path__ + "static/media/my-vinos-user-header.fb9066d6.jpg";